import { IStore } from '..';
import { TAuthInfo } from '../../app/types/authTypes';

export const getIsLogged = (state: IStore): boolean =>
  state.authReducer.isLogged;
export const getUserInfo = (state: IStore): TAuthInfo | null =>
  state.authReducer.userInfo;
export const getIsLoggedOnConnect = (state: IStore): boolean =>
  state.authReducer.ccpInitialized;
